module.exports = __webpack_public_path__ + "static/Truck25-a45a6374a9664f0d05a83ff7e64474a1.png";